import { useSearch } from '@tanstack/react-router';
import { PageHeader } from '@blimo/ui';
import { FilterBar } from '../../components/filter-bar.jsx';
import { useFinanceSearch } from '../../lib/finance-search.js';
import { CostsPanel, OpenItemsPanel, OpTypeToggle, PeriodFilter, PropertyFilter, RentDevelopmentPanel, VatToggle } from './panels.jsx';

/** Finanzen › Offene Posten – all properties (or one), filter state in the URL. */
export function OpenItemsPage() {
  const search = useSearch({ strict: false });
  const { update } = useFinanceSearch(search);
  return (
    <>
      <PageHeader
        title="Offene Posten"
        description="Offene Posten der Mieterkonten (aktuelle und frühere Mietverhältnisse). Negative Beträge sind Rückstände."
      />
      <FilterBar>
        <div className="flex flex-col gap-1">
          <span className="text-xs text-muted-foreground">Art</span>
          <OpTypeToggle value={search.op_type} onChange={(op_type) => update({ op_type })} />
        </div>
        <PropertyFilter value={search.property} onChange={(property) => update({ property })} />
      </FilterBar>
      <OpenItemsPanel propertyId={search.property} opType={search.op_type} />
    </>
  );
}

/** Finanzen › Kosten */
export function CostsPage() {
  const search = useSearch({ strict: false });
  const { period, update } = useFinanceSearch(search);
  return (
    <>
      <PageHeader title="Kosten" description="Kostenbuchungen je Liegenschaft und Sachkonto – Monatswerte und laufende Summe ab Beginn des Zeitraums." />
      <FilterBar>
        <PeriodFilter period={period} onChange={(range) => update(range)} />
        <PropertyFilter value={search.property} onChange={(property) => update({ property })} />
        <VatToggle value={search.vat} onChange={(vat) => update({ vat })} />
      </FilterBar>
      <CostsPanel propertyId={search.property} period={period} vat={search.vat} />
    </>
  );
}

/** Finanzen › Mietentwicklung & Rendite */
export function RentDevelopmentPage() {
  const search = useSearch({ strict: false });
  const { period, update } = useFinanceSearch(search);
  return (
    <>
      <PageHeader title="Mietentwicklung & Rendite" description="Hochgerechnete Jahresmiete und Bruttomietrendite je Monat." />
      <FilterBar>
        <PeriodFilter period={period} onChange={(range) => update(range)} />
        <PropertyFilter value={search.property} onChange={(property) => update({ property })} />
      </FilterBar>
      <RentDevelopmentPanel propertyId={search.property} period={period} />
    </>
  );
}
